import { makeStyles } from "@material-ui/core";
import { green, white, bordo, accentDark } from "../constants/colors";

const useStyles = makeStyles(({ breakpoints: { down }, spacing }) => ({
  mainSection: {
    marginTop: "-200px",
    borderTopRightRadius: "50px",
    borderTopLeftRadius: "50px",
    [down("xs")]: {
      "& h2": {
        fontSize: "17px",
      },
    },
  },
  instructions: {
    marginTop: spacing(1),
    background: "#fff",
    borderRadius: "50px",
    overflow: "hidden",
    marginBottom: "-10px",
    height: "100%",
    [down("xs")]: {
      borderTopRightRadius: "20px",
      borderTopLeftRadius: "20px",
    },
  },
  stepperItem: {
    fontSize: "10px",
    lineHeight: "130%",
    letterSpacing: "0.09em",
    fontFamily: "sbcBold",
    textTransform: "uppercase",
    color: "rgb(244 246 247 / 50%)",
    padding: "5px 10px 5px 10px",
    [down("xs")]: {
      fontSize: "9px",
    },
    "&:last-of-type": {
      borderTopRightRadius: "100px",
      borderBottomRightRadius: "100px",
      // [down("xs")]: {
      //   borderTopRightRadius: "5px",
      //   borderBottomRightRadius: "5px",
      // },
    },
  },
  activeItem: {
    background: green,
    color: white,
    "&:nth-last-match(0)": {
      background: "red",
    },
    zIndex: 1,
    // },
    // [down("xs")]: {
    //   background: "transparent",
    // },
  },
  actualStep: {
    borderTopRightRadius: "100px",
    borderBottomRightRadius: "100px",
    backgroundColor: process.env.REACT_APP_PROJECT === "bcf" ? accentDark : white,
    color: process.env.REACT_APP_PROJECT === "bcf" ? white : bordo,
    // backgroundColor: white,
    // color: bordo,
    position: "relative",
    "&::before": {
      content: "''",
      width: "10px",
      height: "100%",
      position: "absolute",
      left: "-5px",
      top: 0,
      zIndex: 1,
      backgroundColor: green,
      borderTopRightRadius: "100px",
      borderBottomRightRadius: "100px",
      // [down("xs")]: {
      //   content: "none",
      // },
    },
    "&:first-of-type": {
      "&::before": {
        content: "none",
      },
    },
    // [down("xs")]: {
    //   borderRadius: "5px",
    // },
  },
  formMenu: {
    borderRadius: "100px",
    overflow: "hidden",
    // [down("xs")]: {
    //   flexWrap: "wrap",
    // },
  },
  thankYouPage: {
    height: "100%",
    paddingLeft: '16px',
    paddingRight: '16px',
    [down("xs")]: {
      "& h1": {
        fontSize: "23px",
      },
      "& h2": {
        fontSize: "14px",
      },
    },
  },
  mainForm: {
    height: "calc(100vh - 180px)",
    backgroundColor: white,
    padding: "30px 60px",
    borderTopRightRadius: "50px",
    borderTopLeftRadius: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [down("sm")]: {
      padding: "30px 40px",
    },
    [down("xs")]: {
      padding: "25px 10px",
      borderTopRightRadius: "20px",
      borderTopLeftRadius: "20px",
    },
  },
}));

export default useStyles;
